import box from './Box.png';
import carton from './Carton.png';
import stationary from './Stationary.png';
import tag from './Tag.png';

const images = {
    box, carton, stationary, tag
}

export default images;